import { render } from "./AdminsAccess.vue?vue&type=template&id=0d8c7240&scoped=true"
import script from "./AdminsAccess.vue?vue&type=script&lang=js"
export * from "./AdminsAccess.vue?vue&type=script&lang=js"

import "./AdminsAccess.vue?vue&type=style&index=0&id=0d8c7240&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8c7240"]])

export default __exports__